export * from './expression';
export { ExpressionError } from './expressionError';
let expressionFunctions;
export const loadExpressionFunctions = async () => {
    if (expressionFunctions) {
        return;
    }
    const { utils, ...lib } = (await import(
    /* webpackChunkName: "formulajs" */ '@formulajs/formulajs'));
    expressionFunctions = {
        ...lib,
        ...utils.symbols,
    };
};
export const getExpressionFunctions = () => expressionFunctions;
//# sourceMappingURL=index.js.map